// extracted by mini-css-extract-plugin
module.exports = {"base":"Grid_base__gGgdL"};